import { useState } from 'react';
import { Plus, Tag, Trash } from '@phosphor-icons/react';
import Modal from '../../../../../shared/components/Modal';

type TagsListProps = {
  tags: any[];
  t: any;
  onCreate: (name: string) => Promise<boolean>;
  onDelete: (tag: any) => Promise<boolean | void>;
};

export default function TagsList({ tags, t, onCreate, onDelete }: TagsListProps) {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const [pendingDelete, setPendingDelete] = useState<any>();
  const [deleting, setDeleting] = useState(false);

  const create = async () => {
    const trimmedName = name.trim();
    if (!trimmedName || saving) return;
    setSaving(true);
    const created = await onCreate(trimmedName);
    if (created) setName('');
    setSaving(false);
  };

  const remove = async () => {
    if (!pendingDelete || deleting) return;
    setDeleting(true);
    const deleted = await onDelete(pendingDelete);
    setDeleting(false);
    if (deleted !== false) setPendingDelete(undefined);
  };

  return (
    <div className="admin-tags">
      <div className="admin-tag-create">
        <label className="admin-tag-input">
          <Tag />
          <input
            value={name}
            maxLength={40}
            placeholder={t.newTagPlaceholder}
            onChange={(event: any) => setName(event.target.value)}
            onKeyDown={(event: any) => {
              if (event.key === 'Enter') {
                event.preventDefault();
                create();
              }
            }}
          />
        </label>
        <button type="button" className="primary" disabled={!name.trim() || saving} onClick={create}>
          <Plus />{t.createTag}
        </button>
      </div>
      {!tags.length && <p className="admin-tags-empty">{t.noTagsYet}</p>}
      {!!tags.length && (
        <div className="admin-tags-list">
          {tags.map((tag) => (
            <div key={tag.id}>
              <span><Tag />{tag.name}</span>
              <button type="button" aria-label={`${t.delete} ${tag.name}`} onClick={() => setPendingDelete(tag)}>
                <Trash />
              </button>
            </div>
          ))}
        </div>
      )}
      {pendingDelete && (
        <Modal
          label={(t.deleteTagTitle || t.deleteTitle).replace('{name}', pendingDelete.name)}
          onClose={() => !deleting && setPendingDelete(undefined)}
        >
          <div className="confirm-icon"><Trash /></div>
          <div className="modal-head centered">
            <h2>{(t.deleteTagTitle || t.deleteTitle).replace('{name}', pendingDelete.name)}</h2>
            <p>{t.deleteTagText || t.deleteText}</p>
          </div>
          <div className="modal-actions centered">
            <button className="secondary" disabled={deleting} onClick={() => setPendingDelete(undefined)}>
              {t.cancel}
            </button>
            <button className="danger" disabled={deleting} onClick={remove}>
              <Trash />{deleting ? t.pleaseWait : t.delete}
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
}
